import React from "react";
import {Box, Button, Container, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import Hero from "../components/modern/Hero";
import RacePromo from "../components/modern/RacePromo";
import SectionTitle from "../components/modern/SectionTitle";
import EventList from "../components/modern/EventList";
import RiderGrid from "../components/modern/RiderGrid";
import Reveal from "../components/modern/Reveal";
import {today, useEvents, useRiders} from "../data/sheet";
import {colors} from "../styling/GlobalTheme";

function Home() {
    const {data: events} = useEvents();
    const {data: riders} = useRiders();
    const upcoming = events.filter(e => e.end >= today()).slice(0, 4);

    return (
        <>
            <Hero/>

            <Box component="section" id="prochainement" sx={{py: {xs: 8, md: 11}}}>
                <Container maxWidth="lg">
                    <SectionTitle kicker="Agenda" title="Prochainement" subtitle="Les prochaines courses et activités du club."
                                  action={<Button component={Link} to="/activites" variant="outlined" color="inherit">Tout le calendrier</Button>}/>
                    <EventList events={upcoming} emptyText="Le calendrier de la saison arrive bientôt."/>
                </Container>
            </Box>

            <RacePromo/>

            <Box component="section" sx={{py: {xs: 8, md: 11}, bgcolor: colors.night, color: "#fff"}}>
                <Container maxWidth="lg">
                    <SectionTitle light kicker="Champions" title="Nos coureurs" subtitle="Les athlètes du Mouch'Paba, de la relève à la Coupe du monde."
                                  action={<Button component={Link} to="/champions" variant="outlined" sx={{color: "#fff", borderColor: "#fff"}}>Tous les coureurs</Button>}/>
                    <RiderGrid riders={riders} filters={false} limit={4}/>
                </Container>
            </Box>

            <Box component="section" sx={{py: {xs: 8, md: 11}}}>
                <Container maxWidth="lg" sx={{display: "grid", gridTemplateColumns: {xs: "1fr", md: "1fr 1fr"}, gap: {xs: 4, md: 8}, alignItems: "center"}}>
                    <Reveal>
                        <Box sx={{borderRadius: 5, overflow: "hidden", aspectRatio: "4 / 3", boxShadow: "0 30px 60px rgba(11,18,32,.18)"}}>
                            <img src={process.env.PUBLIC_URL + "/images/mouchtec/mouch_5.jpg"} alt="Mouch'Tec" style={{width: "100%", height: "100%", objectFit: "cover"}}/>
                        </Box>
                    </Reveal>
                    <Reveal delay={150}>
                        <Typography sx={{color: colors.glacierDark, fontWeight: 800, letterSpacing: 2, textTransform: "uppercase", fontSize: ".8rem"}}>Relève</Typography>
                        <Typography variant="h2" sx={{fontSize: {xs: "2.6rem", md: "3.6rem"}}}>Mouch'Tec</Typography>
                        <Typography sx={{color: "text.secondary", my: 2}}>
                            Le Mouch'Tec est le groupe d'entraînement du Mouch'Paba. Il est ouvert à toutes les personnes qui souhaitent
                            découvrir le télémark ou améliorer leur technique, avec des activités régulières toute la saison.
                        </Typography>
                        <Box sx={{display: "flex", gap: 1.5, flexWrap: "wrap"}}>
                            <Button variant="contained" color="secondary" component={Link} to="/mouchtec">Découvrir le Mouch'Tec</Button>
                            <Button variant="outlined" color="inherit" component={Link} to="/club">Le club</Button>
                        </Box>
                    </Reveal>
                </Container>
            </Box>
            {/* Bandeau partenaires retiré momentanément : réactiver avec <Partners/> */}
        </>
    );
}

export default Home;
